/** Click effect across th website.
 * Anywhere a click happens, heart emojis show
 */
function flyingHeart(e) {
  const numberOfHearts = Math.floor(Math.random() * 2) + 2;

  for (let i = 0; i < numberOfHearts; i++) {
    const heart = document.createElement("div");
    heart.classList.add("heart");
    heart.textContent = "❤️";

    const offsetX = (Math.random() - 0.5) * 40;
    const offsetY = (Math.random() - 0.5) * 40;

    const xDirection = (Math.random() - 0.5) * 100;
    const yDirection = -Math.random() * 100 - 50;
    const rotation = (Math.random() - 0.5) * 360;

    heart.style.left = `${e.clientX + offsetX}px`;
    heart.style.top = `${e.clientY + offsetY}px`;

    heart.style.setProperty("--x", `${xDirection}px`);
    heart.style.setProperty("--y", `${yDirection}px`);
    heart.style.setProperty("--r", `${rotation}deg`);

    document.body.appendChild(heart);

    setTimeout(() => heart.remove(), 800);
  }
}

// Apply to every click on the page
document.addEventListener("click", flyingHeart);

// Apply on hover of buttons/links
document.querySelectorAll('button, [role="button"], a').forEach((el) => {
  el.addEventListener("mouseenter", (e) => {
    const rect = el.getBoundingClientRect();
    flyingHeart({
      clientX: rect.left + rect.width / 2,
      clientY: rect.top + rect.height / 2,
    });
  });
});

// Your animation observer function remains the same
export function runScrollAnimations() {
  const animatedElements = document.querySelectorAll("[data-animate]");
  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const animation = entry.target.getAttribute("data-animate");
          const delay = entry.target.getAttribute("data-delay") || "0s";
          entry.target.style.animationDelay = delay;
          entry.target.classList.add(`animate-${animation}`);
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  animatedElements.forEach((element) => observer.observe(element));
}

document.addEventListener("DOMContentLoaded", runScrollAnimations);
